"use client"

import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

const NeuralBackground = dynamic(
  () => import("./neural-background").then((mod) => mod.NeuralBackground),
  { ssr: false }
)

export function DeferredNeuralBackground() {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let cancelled = false
    const start = () => {
      if (!cancelled) setEnabled(true)
    }

    window.addEventListener("pointermove", start, { once: true, passive: true })
    window.addEventListener("scroll", start, { once: true, passive: true })
    const timeoutId = window.setTimeout(start, 8000)

    return () => {
      cancelled = true
      window.removeEventListener("pointermove", start)
      window.removeEventListener("scroll", start)
      window.clearTimeout(timeoutId)
    }
  }, [])

  return enabled ? <NeuralBackground /> : null
}
